import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { selectFocusedVideos } from "slices";

import VideoFrame from "./VideoFrame";

const MobileVideoShow = () => {
  const videos = useSelector(selectFocusedVideos);

  const content = (focusedVideo, index) => {
    if (!focusedVideo) {
      return null;
    }

    const videoId = getVideoId(focusedVideo.url);

    if (focusedVideo.url.includes("<iframe")) {
      return (
        <Box key={videoId} className="hayley-flex hayley-flex-col">
          <Box
            className="hayley-flex hayley-h-[240px] hayley-w-full hayley-items-center hayley-justify-center"
            dangerouslySetInnerHTML={{ __html: focusedVideo.url }}
            sx={{ "& iframe": { width: "100%", height: "100%" } }}
          />
          <p className="hayley-m-0 hayley-pb-4 hayley-pt-1 hayley-text-xs hayley-text-secondary">{focusedVideo?.name}</p>
        </Box>
      );
    }

    return <VideoFrame videoId={videoId} focusedVideo={focusedVideo} index={index} />;
  };

  const getVideoId = (url) => {
    if (url.includes("vimeo.com")) {
      return url.split("/").pop();
    } else if (url.includes("youtube.com")) {
      return url.split("=").pop();
    }

    return url;
  };

  return (
    <div id="player" className="hayley-grid hayley-h-full hayley-w-full hayley-overflow-y-auto hayley-bg-gray-100 sm:hayley-hidden">
      {videos?.map(content)}
    </div>
  );
};

export default MobileVideoShow;
